import { AccordionContainer, Text } from '@components';
import { i18n } from '@i18n';
import { useBoostDetailsStore, useTripStore } from '@store';
import { testProps } from '@utils';

import { BenefitsSkeleton } from './benefits.skeleton';

export const Benefits = () => {
  const boostId = useTripStore(
    state => state?.trip?.boosts?.find(it => it.isMandatory)?.boostId ?? '',
  );
  const boostMessage = useBoostDetailsStore(
    state => state.mandatoryBoostDetails?.template?.boostMessage,
  );
  const title = useBoostDetailsStore(state => state.mandatoryBoostDetails?.template?.title);
  const isLoading = useBoostDetailsStore(
    state => state.boostDetailsApiState?.[boostId] === 'pending',
  );

  if (isLoading && !boostMessage) {
    return <BenefitsSkeleton />;
  }

  return (
    <div>
      <div className="flex flex-col sm:flex-row sm:items-center flex-wrap mb-4">
        <Text variant="h3-28/sb" className="pr-1 md:pr-2" {...testProps('benefits-heading')}>
          {title ?? ''}
        </Text>
        <Text variant="h4-24/r" {...testProps('benefits-heading-appendix')}>
          {i18n.t('myQuote.benefitsWhatsIncluded')}
        </Text>
      </div>
      <Text
        variant="body-16/r"
        className="mb-4 md:mb-8"
        {...testProps('benefits-heading-description')}>
        {boostMessage}
      </Text>
      <AccordionContainer />
    </div>
  );
};
